import { Box, Typography, Grid } from "@mui/material";
import data from "../../Assets/data/invitedtalks.json";

const TalksSection = () => {
  return (
    <>
      <>
        <Box
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "2em",
          }}
        >
          <Box
            style={{
              width: "100%",
              background:
                "linear-gradient(180deg, #004C98 0%, rgba(90, 139, 188, 0.646736) 38.69%, rgba(255, 255, 255, 0) 100%)",
            }}
          >
            <Typography
              style={{
                padding: "32px",
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
                boxSizing: "border-box",
                marginRight: "32px",
              }}
              fontSize="32px"
              fontWeight={600}
            >
              Invited Talks and Lectures
            </Typography>
          </Box>
          <Box
            style={{
              maxWidth: "960px",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  fontWeight={600}
                  fontSize="26px"
                  margin="16px 0px 6px"
                >
                  Invited talks and lectures
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {data.map((talk, i) => {
                  return (
                    <Box key={i} style={{ marginBottom: "12px" }}>
                      <Typography fontWeight={600} fontSize="18px">
                        {talk.topic}
                      </Typography>
                      <Typography>{talk.location}</Typography>
                      <Typography>{talk.date}</Typography>
                    </Box>
                  );
                })}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default TalksSection;
